(function () {
  function initCountdown(section) {
    if (section.dataset.summerDealTimer) clearInterval(Number(section.dataset.summerDealTimer));
    const date = new Date(section.dataset.summerDealCountdown).getTime();
    if (Number.isNaN(date)) return;
    const update = function () {
      const remaining = Math.max(0, date - Date.now());
      const values = [Math.floor(remaining / 86400000), Math.floor(remaining / 3600000) % 24, Math.floor(remaining / 60000) % 60, Math.floor(remaining / 1000) % 60];
      ['days', 'hours', 'minutes', 'seconds'].forEach(function (name, index) {
        const element = section.querySelector('[data-sd-' + name + ']');
        if (element) element.textContent = String(values[index]).padStart(2, '0');
      });
      return remaining > 0;
    };
    if (!update()) return;
    const id = setInterval(function () { if (!update()) clearInterval(id); }, 1000);
    section.dataset.summerDealTimer = id;
  }

  document.querySelectorAll('[data-summer-deal-countdown]').forEach(initCountdown);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-summer-deal-countdown]').forEach(initCountdown);
  });
  document.addEventListener('click', function (event) {
    const gameButton = event.target.closest('.summer-deal-surprise__game');
    if (gameButton && typeof window.eaOpenPopup === 'function') window.eaOpenPopup();

    const playButton = event.target.closest('[data-sd-video-play]');
    if (playButton) {
      const media = playButton.closest('.summer-deal-bonus__media'); const video = playButton.previousElementSibling;
      if (!media || !video || video.tagName !== 'VIDEO') return;
      media.classList.add('is-playing'); video.controls = true;
      video.play().catch(function () { media.classList.remove('is-playing'); video.controls = false; });
    }
    const quantityButton = event.target.closest('[data-sd-quantity]');
    if (quantityButton) {
      const root = quantityButton.closest('.summer-deal-product-card, .summer-deal-bonus__body');
      const form = root && root.querySelector('form'); const display = root && root.querySelector('[data-sd-quantity-value]');
      const input = form && form.querySelector('[name="quantity"]'); if (!input || !display) return;
      input.value = Math.max(1, Number(input.value) + Number(quantityButton.dataset.sdQuantity)); display.textContent = input.value;
    }
    const buyButton = event.target.closest('[data-sd-buy-now]');
    if (buyButton && !buyButton.disabled) {
      const form = document.getElementById(buyButton.dataset.form); const quantity = form && form.querySelector('[name="quantity"]');
      const variant = form && form.elements.namedItem('id');
      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      window.location.href = root + 'cart/' + (variant ? variant.value : buyButton.dataset.variantId) + ':' + (quantity ? quantity.value : 1);
    }
  });

})();
